import { render, staticRenderFns } from "./DeadlineCountdownTimer.vue?vue&type=template&id=0080af73"
import script from "./DeadlineCountdownTimer.vue?vue&type=script&lang=ts"
export * from "./DeadlineCountdownTimer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports